import { CustomFieldInputs } from 'src/common/components/Filters/Inputs/customFields/CustomFieldsInputs';
import { customFieldsFilterAtom } from 'atoms/filters/sim-products';
import { customFieldsHintsAtom } from 'src/atoms/hints/sim-products';

export const SimProductCustomFieldInputs = () => {
  return (
    <CustomFieldInputs
      customFieldsFilterAtom={customFieldsFilterAtom}
      customFieldsHintsAtom={customFieldsHintsAtom}
    />
  );
};
